import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { connect } from 'react-redux';
import * as menuActions from '../store/actions/breadcrumb';
import userManualPdf from'../config/user-manual.pdf'
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const UserManual = ({
  setBreadcrumb, 
}) => {
  const { t } = useTranslation('common');

useEffect(() => {
  setBreadcrumb(t('User Manual'))
}, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
          <h1 className='page-heading' ><b>{t("User Manual")}</b></h1>
        </Grid>
      </Grid>
      <hr className='blue-border' />
      <Grid container spacing={2} className='mt-20'>
      <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
        <div style={{ width: '100%', height: '100vh' }}>
            <iframe
              title="PDF Viewer"
              src={userManualPdf}
              width="100%"
              height="100%"
            >
              {t("This browser does not support PDFs Please download the PDF to view it")}
            </iframe>
          </div>
        </Grid>
      
      </Grid>
      </div>
  );
}
const mapStateToProps = (state) => ({ 
  })

const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
    };
};
UserManual.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManual);


